import './sass/main.scss';
import './js/eventFinder';
import './js/modal';
import './js/eventsFilter';
import './js/openRegistration';
import './js/registration';